import { IconPointFilled as GenericAuthorIcon } from '@tabler/icons-react';
import { Outlet, createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { ContextSidebar } from '@/core/components/RootLayout/Sidebar/ContextSidebar';

export const Route = createFileRoute('/_auth/author/_author')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.author' },
  },
});

function RouteComponent() {
  const { t } = useTranslation();

  const authorTabs = [
    { label: t('sidebar.articles'), to: 'article', icon: GenericAuthorIcon },
    // { label: t('sidebar.reviews'), to: 'review', icon: GenericAuthorIcon },
    { label: t('sidebar.abstracts'), to: 'abstract', icon: GenericAuthorIcon },
    { label: t('sidebar.books'), to: 'book', icon: GenericAuthorIcon },
    { label: t('sidebar.chapters'), to: 'chapter', icon: GenericAuthorIcon },
    { label: t('sidebar.proceedings'), to: 'proceeding', icon: GenericAuthorIcon },
    { label: t('sidebar.translations'), to: 'translation', icon: GenericAuthorIcon },
    { label: t('sidebar.projects'), to: 'project', icon: GenericAuthorIcon },
    { label: t('sidebar.patents'), to: 'patent', icon: GenericAuthorIcon },
    { label: t('sidebar.courses'), to: 'course', icon: GenericAuthorIcon },
    { label: t('sidebar.awards'), to: 'award', icon: GenericAuthorIcon },
    { label: t('sidebar.committees'), to: 'committee', icon: GenericAuthorIcon },
  ];

  return (
    <>
      <ContextSidebar
        baseUrl="author"
        items={authorTabs}
      />
      <Outlet />
    </>
  );
}
